// =============================================================================
// O modo embutido: o Painel do Gestor dentro do Arena (22/10)
//
// O Arena (portal do colaborador) mostra o Nexa no endereço `/embed/gestor`,
// numa moldura. Ali a tela é só a do gestor (Embutido.tsx), sem o menu do Nexa,
// e o login não pode ir ao Google na própria página: o Google recusa aparecer
// dentro de outra. Quem decide que o Arena pode emoldurar é o servidor
// (api/src/moldura.ts), e só neste endereço.
// =============================================================================

export const EMBUTIDO = typeof location !== "undefined" && location.pathname.startsWith("/embed/");

/** Avisado quando a API responde 401 no modo embutido: a tela mostra o login. */
export const EVENTO_SEM_SESSAO = "nexa:sem-sessao";
